import { recipe } from "@vanilla-extract/recipes";

export const stackStyle = recipe({
  base: {
    display: "grid",
    gridTemplateRows: "1fr",
    gridTemplateColumns: "1fr",
    height: "100%",
    width: "100%",
    selectors: {
      "&:empty": {
        display: "none",
      },
    },
  },
  variants: {
    overflowHidden: {
      true: {
        overflow: "hidden",
      },
    },
    grow: {
      true: {
        flexGrow: 1,
      },
    },
  },
});

export const childStyle = recipe({
  base: {
    gridRow: "1 / -1",
    gridColumn: "1 / -1",
    height: "100%",
    width: "100%",
    selectors: {
      "&:empty": {
        display: "none",
      },
    },
  },
  variants: {
    overflowHidden: {
      true: {
        overflow: "hidden",
      },
    },
  },
});
